(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cn-collection-grid-new"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cn-load-more')) {
    customElements.define(
      'cn-load-more',
      class CnLoadMore extends HTMLElement {
        connectedCallback() {
          this.gridId = this.dataset.gridId || 'product-grid';
          this.grid = document.getElementById(this.gridId);
          this.btn = this.querySelector('[data-load-more-btn]');
          this.loading = false;
          this.handleClick = this.onLoadMore.bind(this);
          this.btn?.addEventListener('click', this.handleClick);
        }

        disconnectedCallback() {
          this.btn?.removeEventListener('click', this.handleClick);
        }

        async onLoadMore() {
          if (!this.btn.dataset.href || this.loading) {
            return;
          }

          this.loading = true;
          this.btn.setAttribute('aria-busy', 'true');
          this.btn.setAttribute('disabled', '');

          try {
            const response = await fetch(this.btn.dataset.href);
            if (!response.ok) {
              throw new Error(`HTTP ${response.status}`);
            }
            const text = await response.text();
            const doc = new DOMParser().parseFromString(text, 'text/html');
            const newGrid = doc.getElementById(this.gridId);

            if (newGrid) {
              [...newGrid.children].forEach((item) => this.grid.appendChild(item));
            }

            const nextBtn = doc.querySelector('[data-load-more-btn]');
            if (nextBtn?.dataset.href) {
              this.btn.dataset.href = nextBtn.dataset.href;
            } else {
              this.closest('cn-load-more')?.remove();
            }
          } catch {
            // fail silently — button re-enables so user can retry
          } finally {
            this.loading = false;
            this.btn.removeAttribute('aria-busy');
            this.btn.removeAttribute('disabled');
          }
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cn-collection-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cn-load-more')) {
    customElements.define(
      'cn-load-more',
      class CnLoadMore extends HTMLElement {
        connectedCallback() {
          this.gridId = this.dataset.gridId || 'product-grid';
          this.grid = document.getElementById(this.gridId);
          this.btn = this.querySelector('[data-load-more-btn]');
          this.loading = false;
          this.handleClick = this.onLoadMore.bind(this);
          this.btn?.addEventListener('click', this.handleClick);
        }

        disconnectedCallback() {
          this.btn?.removeEventListener('click', this.handleClick);
        }

        async onLoadMore() {
          if (!this.btn.dataset.href || this.loading) {
            return;
          }

          this.loading = true;
          this.btn.setAttribute('aria-busy', 'true');
          this.btn.setAttribute('disabled', '');

          try {
            const response = await fetch(this.btn.dataset.href);
            if (!response.ok) {
              throw new Error(`HTTP ${response.status}`);
            }
            const text = await response.text();
            const doc = new DOMParser().parseFromString(text, 'text/html');
            const newGrid = doc.getElementById(this.gridId);

            if (newGrid) {
              [...newGrid.children].forEach((item) => this.grid.appendChild(item));
            }

            const nextBtn = doc.querySelector('[data-load-more-btn]');
            if (nextBtn?.dataset.href) {
              this.btn.dataset.href = nextBtn.dataset.href;
            } else {
              this.closest('cn-load-more')?.remove();
            }
          } catch {
            // fail silently — button re-enables so user can retry
          } finally {
            this.loading = false;
            this.btn.removeAttribute('aria-busy');
            this.btn.removeAttribute('disabled');
          }
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cn-open-edition-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cn-load-more')) {
    customElements.define(
      'cn-load-more',
      class CnLoadMore extends HTMLElement {
        connectedCallback() {
          this.gridId = this.dataset.gridId || 'product-grid';
          this.grid = document.getElementById(this.gridId);
          this.btn = this.querySelector('[data-load-more-btn]');
          this.loading = false;
          this.handleClick = this.onLoadMore.bind(this);
          this.btn?.addEventListener('click', this.handleClick);
        }

        disconnectedCallback() {
          this.btn?.removeEventListener('click', this.handleClick);
        }

        async onLoadMore() {
          if (!this.btn.dataset.href || this.loading) {
            return;
          }

          this.loading = true;
          this.btn.setAttribute('aria-busy', 'true');
          this.btn.setAttribute('disabled', '');

          try {
            const response = await fetch(this.btn.dataset.href);
            if (!response.ok) {
              throw new Error(`HTTP ${response.status}`);
            }
            const text = await response.text();
            const doc = new DOMParser().parseFromString(text, 'text/html');
            const newGrid = doc.getElementById(this.gridId);

            if (newGrid) {
              [...newGrid.children].forEach((item) => this.grid.appendChild(item));
            }

            const nextBtn = doc.querySelector('[data-load-more-btn]');
            if (nextBtn?.dataset.href) {
              this.btn.dataset.href = nextBtn.dataset.href;
            } else {
              this.closest('cn-load-more')?.remove();
            }
          } catch {
            // fail silently — button re-enables so user can retry
          } finally {
            this.loading = false;
            this.btn.removeAttribute('aria-busy');
            this.btn.removeAttribute('disabled');
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cn-portrait-collection-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cn-load-more')) {
    customElements.define(
      'cn-load-more',
      class CnLoadMore extends HTMLElement {
        connectedCallback() {
          this.gridId = this.dataset.gridId || 'product-grid';
          this.grid = document.getElementById(this.gridId);
          this.btn = this.querySelector('[data-load-more-btn]');
          this.loading = false;
          this.handleClick = this.onLoadMore.bind(this);
          this.btn?.addEventListener('click', this.handleClick);
        }

        disconnectedCallback() {
          this.btn?.removeEventListener('click', this.handleClick);
        }

        async onLoadMore() {
          if (!this.btn.dataset.href || this.loading) {
            return;
          }

          this.loading = true;
          this.btn.setAttribute('aria-busy', 'true');
          this.btn.setAttribute('disabled', '');

          try {
            const response = await fetch(this.btn.dataset.href);
            if (!response.ok) {
              throw new Error(`HTTP ${response.status}`);
            }
            const text = await response.text();
            const doc = new DOMParser().parseFromString(text, 'text/html');
            const newGrid = doc.getElementById(this.gridId);

            if (newGrid) {
              [...newGrid.children].forEach((item) => this.grid.appendChild(item));
            }

            const nextBtn = doc.querySelector('[data-load-more-btn]');
            if (nextBtn?.dataset.href) {
              this.btn.dataset.href = nextBtn.dataset.href;
            } else {
              this.closest('cn-load-more')?.remove();
            }
          } catch {
            // fail silently — button re-enables so user can retry
          } finally {
            this.loading = false;
            this.btn.removeAttribute('aria-busy');
            this.btn.removeAttribute('disabled');
          }
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ctm-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faq-accordion')) {
    customElements.define(
      'faq-accordion',
      class FaqAccordion extends HTMLElement {
        connectedCallback() {
          this.handlers = [];
          this.querySelectorAll('.ctm-faq__item').forEach((item) => {
            const btn = item.querySelector('.ctm-faq__question');
            const handler = this.onToggle.bind(this, item);
            this.handlers.push({ btn, handler });
            btn.addEventListener('click', handler);
          });
        }

        disconnectedCallback() {
          this.handlers.forEach(({ btn, handler }) => {
            btn.removeEventListener('click', handler);
          });
        }

        closeItem(item) {
          const btn = item.querySelector('.ctm-faq__question');
          const answer = item.querySelector('.ctm-faq__answer');
          const icon = btn.querySelector('.ctm-faq__icon');
          btn.setAttribute('aria-expanded', 'false');
          answer.setAttribute('aria-hidden', 'true');
          icon.textContent = '+';
        }

        onToggle(item) {
          const btn = item.querySelector('.ctm-faq__question');
          const answer = item.querySelector('.ctm-faq__answer');
          const icon = btn.querySelector('.ctm-faq__icon');
          const isExpanded = btn.getAttribute('aria-expanded') === 'true';

          this.querySelectorAll('.ctm-faq__item').forEach((other) => {
            if (other !== item) {
              this.closeItem(other);
            }
          });

          if (isExpanded) {
            btn.setAttribute('aria-expanded', 'false');
            answer.setAttribute('aria-hidden', 'true');
            icon.textContent = '+';
          } else {
            btn.setAttribute('aria-expanded', 'true');
            answer.setAttribute('aria-hidden', 'false');
            icon.textContent = '-';
          }
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ctm-limited-collection-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('le-acquire-btn')) {
    customElements.define(
      'le-acquire-btn',
      class LeAcquireBtn extends HTMLElement {
        connectedCallback() {
          this.btn = this.querySelector('[data-btn]');
          this.handleClick = this.onAcquire.bind(this);
          this.btn?.addEventListener('click', this.handleClick);
        }

        disconnectedCallback() {
          this.btn?.removeEventListener('click', this.handleClick);
        }

        async onAcquire(event) {
          event.preventDefault();
          const variantId = this.dataset.variantId;
          if (!variantId || this.dataset.loading === 'true') {
            return;
          }

          this.setLoading(true);

          try {
            const addRes = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
            });

            if (!addRes.ok) {
              throw new Error('add-to-cart-failed');
            }

            await this.refreshCart();
          } catch {
            window.location.href = this.dataset.productUrl || '/cart';
          } finally {
            this.setLoading(false);
          }
        }

        setLoading(state) {
          this.dataset.loading = String(state);
          if (this.btn) {
            this.btn.disabled = state;
            this.btn.setAttribute('aria-busy', String(state));
          }
        }

        async refreshCart() {
          const res = await fetch('/?sections=cart-drawer,cart-icon-bubble');
          if (!res.ok) {
            window.location.href = '/cart';
            return;
          }

          const sections = await res.json();
          this.updateCartBubble(sections['cart-icon-bubble']);
          this.openCartDrawer(sections['cart-drawer']);
        }

        updateCartBubble(html) {
          if (!html) {
            return;
          }
          const temp = document.createElement('div');
          temp.innerHTML = html;
          const newBubble = temp.querySelector('.cart-count-bubble');
          const oldBubble = document.querySelector('.cart-count-bubble');
          if (newBubble && oldBubble) {
            oldBubble.replaceWith(newBubble);
          } else if (newBubble) {
            const cartLink = document.getElementById('cart-icon-bubble');
            if (cartLink) {
              cartLink.appendChild(newBubble);
            }
          }
        }

        openCartDrawer(html) {
          const drawer = document.querySelector('cart-drawer');
          if (!drawer || !html) {
            window.location.href = '/cart';
            return;
          }

          const temp = document.createElement('div');
          temp.innerHTML = html;

          const targets = ['cart-drawer-items', '.drawer__footer'];
          targets.forEach((selector) => {
            const newEl = temp.querySelector(selector);
            const oldEl = drawer.querySelector(selector);
            if (newEl && oldEl) {
              oldEl.replaceWith(newEl);
            }
          });

          if (typeof drawer.open === 'function') {
            drawer.open();
          } else {
            window.location.href = '/cart';
          }
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ctm-process"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ctm-process')) {
    customElements.define(
      'ctm-process',
      class CtmProcess extends HTMLElement {
        connectedCallback() {
          this.line = this.querySelector('[data-process-line]');
          this.dot = this.querySelector('[data-process-dot]');
          this.stepsCol = this.querySelector('[data-process-steps]');
          this.timelineColor = this.dataset.timelineColor || '#e18131';

          if (!this.stepsCol) return;

          this.ticking = false;
          this.handleScroll = this.onScroll.bind(this);
          window.addEventListener('scroll', this.handleScroll, { passive: true });
          this.onScroll();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.handleScroll);
        }

        onScroll() {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.update();
            this.ticking = false;
          });
        }

        update() {
          const rect = this.getBoundingClientRect();
          const viewH = window.innerHeight;
          const trackH = this.stepsCol.offsetHeight;

          const scrolledIn = Math.max(0, -rect.top);
          const scrollable = Math.max(1, rect.height - viewH);
          const progress = Math.min(1, scrolledIn / scrollable);
          const lineH = Math.round(trackH * progress);

          if (this.line) {
            this.line.style.height = `${lineH}px`;
          }
          if (this.dot) {
            this.dot.style.top = `${lineH}px`;
          }

          const steps = this.querySelectorAll('[data-process-step]');
          const stepsTop = this.stepsCol.getBoundingClientRect().top;
          let activeIndex = -1;

          steps.forEach((step, i) => {
            const heading = step.querySelector('[data-process-heading]');
            const triggerEl = heading || step;
            const triggerTopInCol = triggerEl.getBoundingClientRect().top - stepsTop;
            if (triggerTopInCol <= lineH) {
              activeIndex = i;
            }
          });

          steps.forEach((step, i) => {
            const heading = step.querySelector('[data-process-heading]');
            if (!heading) return;
            heading.style.color = i === activeIndex ? this.timelineColor : '#000000';
          });
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Mega menu: open on hover (desktop only)
  const megaMenuItems = document.querySelectorAll('header-menu');

  megaMenuItems.forEach((menu) => {
    const details = menu.querySelector('details.mega-menu');
    if (!details) return;

    let closeTimer;

    menu.addEventListener('mouseenter', () => {
      if (window.innerWidth < 990) return;
      clearTimeout(closeTimer);
      if (!details.open) {
        details.open = true;
      }
    });

    menu.addEventListener('mouseleave', () => {
      if (window.innerWidth < 990) return;
      closeTimer = setTimeout(() => {
        menu.close();
      }, 150);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ctm-newsletter__form').forEach((form) => {
    const checkbox = form.querySelector('.ctm-newsletter__consent');
    const submitBtn = form.querySelector('.ctm-newsletter__submit');
    if (!checkbox || !submitBtn) return;
    checkbox.addEventListener('change', () => {
      submitBtn.disabled = !checkbox.checked;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
